import {Trans} from '@lingui/macro'
import type {FC} from 'react'
import {Link, Outlet} from 'react-router-dom'

import {Button} from '@pleo-io/telescope'

import {Page} from '~/generic-ui/page'
import {Tabs, Tab} from '~/generic-ui/tabs/tabs'
import {getIsFdd, useLoggedInUser} from '~/shell/user'

const GeneralSettingsWrapper: FC = () => {
    const user = useLoggedInUser()
    const isFdd = getIsFdd(user)
    const ownerAccess = user.role === 'owner' || user.role === 'bookkeeper-extended'

    return (
        <Page layout="wide" showNav>
            <Page.Header>
                <Page.Backlink>
                    <Button variant="link" to="/settings" as={Link}>
                        &larr; <Trans>Back to Settings</Trans>
                    </Button>
                </Page.Backlink>
                <Page.Title>
                    <Trans>General</Trans>
                </Page.Title>
                <Page.Tabs>
                    <Tabs>
                        {ownerAccess && (
                            <Tab to="/settings/general/billing" testId="billing-tab">
                                <Trans>Billing</Trans>
                            </Tab>
                        )}
                        {isFdd && (
                            <Tab to="/settings/general/card-defaults" testId="card-defaults-tab">
                                <Trans>Card defaults</Trans>
                            </Tab>
                        )}
                        <Tab to="/settings/general/company" testId="company-tab">
                            <Trans>Company info</Trans>
                        </Tab>
                    </Tabs>
                </Page.Tabs>
            </Page.Header>

            <Outlet />
        </Page>
    )
}

export default GeneralSettingsWrapper
